// @ts-nocheck
import { KeyValuePipe } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import { IconComponent } from '@lbca-shared/icon';
import {
  flatten as flattenRamda,
  has as hasRamda,
  ifElse as ifElseRamda,
  map as mapRamda,
  path as pathRamda,
  pipe as pipeRamda,
  prop as propRamda,
} from 'ramda';
import { Subscription } from 'rxjs';
import { ASSETS } from '../../../../assets/assets';
import { NgTryForDirective } from '../../../../directives/_old_directives/ng-try-for.directive';
import { LoadingComponent } from '../../../_old_general-components/loading/loading.component';
import { BodyFeedbackComponent } from '../../body-feedback/body-feedback.component';
import { ISubForm } from '../dynamic-form.model';
import { DynamicFormService } from '../dynamic-form.service';
import { CcoV2Component } from '../sub-modules/cco-v2/cco-v2.component';
import { CcoComponent } from '../sub-modules/cco/cco.component';
import { ClaimComponent } from '../sub-modules/claim/claim.component';
import { FileUploadComponent } from '../sub-modules/file-upload/file-upload.component';
import { FormTemplateComponent } from '../sub-modules/form-template/form-template.component';
import { LegalRequestComponent } from '../sub-modules/legal-request/legal-request.component';
import { LinkedCasesComponent } from '../sub-modules/linked-cases/linked-cases.component';
import { ParallelTableComponent } from '../sub-modules/parallel-table/parallel-table.component';
import { ParallelTasksComponent } from '../sub-modules/parallel-tasks/parallel-tasks.component';
import { SearchModuleComponent } from '../sub-modules/search-module/search-module.component';
import { SubModuleFormComponent } from '../sub-modules/sub-form/subform.component';
import { TaskDistributionComponent } from '../sub-modules/task-distribution/task-distribution.component';

@Component({
  selector: 'lbca-dynamic-form-module',
  templateUrl: './module.component.html',
  styleUrl: './module.component.scss',

  imports: [
    LoadingComponent,
    BodyFeedbackComponent,
    SubModuleFormComponent,
    ParallelTableComponent,
    TaskDistributionComponent,
    CcoComponent,
    CcoV2Component,
    SearchModuleComponent,
    LinkedCasesComponent,
    FormTemplateComponent,
    ClaimComponent,
    LegalRequestComponent,
    ParallelTasksComponent,
    FileUploadComponent,
    NgTryForDirective,
    KeyValuePipe,
    IconComponent,
  ],
})
export class ModuleComponent implements OnInit, OnDestroy {
  readonly assets = inject(ASSETS);
  @ViewChild('HeaderModule') headerModule!: ElementRef;

  public hasRequerid = false;
  public loadPage = false;
  public isOpen = true;
  public isAllFilled = false;
  public dependencyNotReady = false;
  public hasError = false;
  public allRequiredfilled = false;
  public disabled = false;
  public waitingDelay = false;
  public editParallel: boolean = true;
  public origin = '';

  public moduleDataRef = '';
  public cardInfo: any;

  private loadAttr = false;
  private loadProcessId = false;
  private loadAttrValues = false;
  public flowId = '';

  public fieldsLabels: any = {};

  validateFiles = false;

  dependenceMessages: { primary: string; secondary: string[] } = {
    primary: '',
    secondary: [],
  };

  public formType: 'form-primary' | 'modal' | 'form-secondary' = 'form-primary';

  cloudSaveStatus: 'saved' | 'saving' | 'error' | 'init' = 'init';

  public subFormModuleInstance: any = null;
  public gridFormModuleInstance: any = null;
  public subFormModuleInstanceForFileUpload: any = null;
  @Input()
  set type(type: 'form-primary' | 'modal' | 'form-secondary') {
    this.formType = type;
  }

  @Input('disabled')
  set disabledSetter(status: boolean) {
    this.disabled = status;
  }
  public extData = {};

  @Input('externalData')
  set data(data: any) {
    if (data) {
      this.extData = data.preLoadedData;
      if (data.hasOwnProperty('flowId')) {
        this.flowId = data.flowId;
      }
      setTimeout(() => {
        if (this.configuration.type == 'SUBFORM' && this.configuration.fields) {
          this.configuration.fields.forEach((row) => {
            row.forEach((field) => {
              const { entityKey, entityRecoverKey } = field;
              if (data.preLoadedData && data.preLoadedData[entityKey as string]) {
                if (!(data[entityRecoverKey as string] || data[entityKey as string])) {
                  data[entityKey as string] = data.preLoadedData[entityKey as string];
                }
              }
              if (this.subFormModuleInstance) {
                this.subFormModuleInstance(entityKey as string, 'valid', true);
                this.subFormModuleInstance(
                  entityKey as string,
                  'propertiesValued',
                  data[entityRecoverKey as string]
                );
              }
              this.entityDataProcess = {
                ...this.entityDataProcess,
                ...{ [entityKey as string]: data[(entityRecoverKey ?? entityKey) as string] },
              };
            });
          });
        } else if (this.configuration.type == 'TASK_DISTRIBUTION') {
          this.entityDataProcess = data[this.configuration.entityKey];
        } else if (this.configuration.type == 'CCO_V2' && this.configuration.fields) {
          this.entityDataProcess = { ...data };
          this.configuration.fields.forEach((row) => {
            row.forEach((field: any) => {
              const { entityKey, entityRecoverKey } = field;
              this.entityDataProcess[entityKey] = data[entityRecoverKey ?? entityKey];
            });
          });
        } else {
          this.moduleDataRef = data[this.configuration.entityKey];
        }
      }, 300);
    }
  }
  @Input()
  set cardData(data: any) {
    this.cardInfo = data;
  }

  private moduloInicializatedSaveBlock = true;

  public initialized = false;
  @Input('initialized')
  set initializedValue(initialized: boolean) {
    this.initialized = initialized;
  }

  entityDataProcess: any = null;

  private autoSaveInterval = null;

  configuration: ISubForm = {
    disable: true,
    label: '',
    id: '',
    entityKey: '',
    entityId: '',
    type: '',
  };

  context: any = null;

  @Input('origin') set setOrigin(val: string) {
    this.origin = val;
  }
  @Input('context') set contextSetter(val: string) {
    this.context = val;
  }

  public dataAttr = {};
  @Input('dataAttr') set dataAt(data) {
    if (data) {
      this.dataAttr = {
        ...this.dataAttr,
        ...data,
      };
    } else {
      this.dataAttr = {
        ...this.dataAttr,
      };
    }
  }

  public processId;
  @Input('processId') set processIdSetter(data) {
    this.processId = data;
    if (data) {
      this.dataAttr = {
        ...this.dataAttr,
        processNumber: data,
      };
    } else {
      this.dataAttr = {
        ...this.dataAttr,
      };
    }
  }

  public davaValues;
  @Input('davaValues') set davaValuesSetter(data) {
    if (data) {
      this.dataAttr = {
        ...this.dataAttr,
        ...data,
      };
    } else {
      this.dataAttr = {
        ...this.dataAttr,
      };
    }
  }

  @Input('configuration')
  set config(data: any) {
    this.configuration = data;
  }

  @Input('forceStateOpened')
  set openStatus(isOpen: boolean) {
    this.isOpen = isOpen;
  }
  errors = [];
  @Input('error') set err(error) {
    this.errors = error;
  }

  @Output() setControlCloud = new EventEmitter();

  @Output() setDataDependence = new EventEmitter();

  @Output('saveData') saveDataEmmiter = new EventEmitter();
  @Output('formValidFunctionCallback') formValidCalbackEmmiter = new EventEmitter();
  @Output('errorApi') errorApiEmmiter = new EventEmitter();

  moduleSubscription!: Subscription;
  formSubscription!: Subscription;

  constructor(public dynamicFormService: DynamicFormService) {}

  eventParallelEmitter($event) {}

  ngOnInit(): void {
    this.fieldsLabels = this.assets.labels.components.fields;
    this.dependenceMessages.primary =
      this.assets.labels.pages.form.formDependences['dependence-header'];

    this.moduleSubscription = this.dynamicFormService.moduleErrorEmitter.subscribe(
      (moduleId: string) => {
        if (moduleId === this.configuration.id) this.validationCallback();
      }
    );

    this.formValidCalbackEmmiter.emit(this.validationCallback);

    if (this.configuration.type == 'FILE_UPLOAD') {
      if (this.configuration.required) {
        this.hasRequerid = true;
      }
      this.subFormModuleInstanceForFileUpload = this.dynamicFormService.setFormControlData(
        this.configuration.id
      );
    } else if (this.configuration.type == 'CCO') {
      if (this.configuration.required) {
        this.hasRequerid = true;
      }
    } else {
      let gridboxValidator = false;
      if (this.configuration.type == 'PARALLEL_TASK') {
        gridboxValidator = true;
        this.gridFormModuleInstance = this.dynamicFormService.setGridFormControlData(
          this.configuration.entityKey
        );
      }

      if (this.configuration.fields && !gridboxValidator)
        this.configuration.fields.forEach((subform) => {
          if (Array.isArray(subform)) {
            subform
              .filter((filterGrid) => filterGrid.type == 'GRIDBOX')
              .forEach((gridList) => {
                // subform = true;
                this.gridFormModuleInstance = this.dynamicFormService.setGridFormControlData(
                  gridList.entityKey
                );
                this.gridFormModuleInstance(gridList.entityKey, 'required', gridList.required);
                this.gridFormModuleInstance(gridList.entityKey, 'error', []);
              });
          }
        });

      if (!gridboxValidator)
        this.subFormModuleInstance = this.dynamicFormService.setFormControlData(
          this.configuration.id
        );

      // this.dynamicFormService.getControllDependencyEmmiter.subscribe(controllData => {
      //   this.analyseDependency(controllData);
      // })

      // this.dynamicFormService.getControllFormEmmiter.subscribe(controllData => {

      //   this.isAllFilled = true;
      //   this.hasRequerid = false;
      //   this.hasError = false;

      //   if (!controllData[this.configuration.id]) return;

      //   this.validateDependency(controllData)

      //   Object.keys(controllData[this.configuration.id].fields).forEach(key => {
      //     if (controllData[this.configuration.id].fields[key].required &&
      //       controllData[this.configuration.id].fields[key].visible) {
      //       this.hasRequerid = true;
      //       this.isAllFilled = this.isAllFilled && controllData[this.configuration.id].fields[key].value ? true : controllData[this.configuration.id].fields[key].value === false ? true : false;
      //     }

      //     const errorForm = controllData[this.configuration.id].fields[key].error;

      //     if (errorForm) {
      //       this.hasError = this.hasError || errorForm.length > 0;
      //     }
      //   });
      // })

      // if (this.configuration.fields)
      //   this.configuration.fields.forEach(
      //     row => row.forEach(
      //       field => {
      //         this.subFormModuleInstance(field.entityKey, 'required', field.required);
      //         this.subFormModuleInstance(field.entityKey, 'error', []);

      //         if (field.childrenDependency) {
      //           if (field.childrenDependency.controllDependency) return
      //           field.childrenDependency['controllDependency'] = { ...field.childrenDependency.defaultCondition }
      //           field.childrenDependency['inicializated'] = true;
      //           this.subFormModuleInstance(field.entityKey, 'visible', field.childrenDependency.controllDependency.visible);
      //         } else {
      //           this.subFormModuleInstance(field.entityKey, 'visible', true);
      //         }
      //       }
      //     )
      //   );

      this.formSubscription = this.dynamicFormService.formControlStructureChanged.subscribe(
        (data) => {
          if (this.hasError && this.configuration.type != 'TASK_DISTRIBUTION') {
            let moduleHasError = false;
            data.moduleControl[this.configuration.id].fields.forEach((field) => {
              if (data.fieldControl[field].error.length > 0) {
                moduleHasError = true;
              }
            });
            this.hasError = moduleHasError;
          }
        }
      );
    }

    setTimeout(() => (this.waitingDelay = true), 400);

    // this.getFormData();
  }

  ngOnDestroy(): void {
    this.moduleSubscription?.unsubscribe();
    this.formSubscription?.unsubscribe();
  }

  public resetError() {
    this.hasError = false;
  }

  private validateDependency(controllData): void {
    // const subform = controllData[this.configuration.id];
    // if (hasControll) {
    //   const fieldsDependencyKeys = subform.controll.fieldDependency.map(item => item.entityKey);
    //   const relyOnSubform = subform.relyOnModule;
    //   let auxResolve = true;
    //   fieldsDependencyKeys.forEach(key => {
    //     auxResolve = auxResolve && subform.fields[key].valid
    //   })
    //   // this.dynamicFormService.setControllData(this.configuration.id, 'resolved', auxResolve)
    // }
  }

  private validationCallback = () => {
    let emptyArray;

    this.resetError();
    if (this.configuration.type == 'SUBFORM') {
      const { fieldControl, moduleControl } = this.dynamicFormService.formControlStructure;

      if (!moduleControl[this.configuration.id].locked) {
        const allFieldsThisModule = pipeRamda(
          pathRamda(['configuration', 'fields']),
          flattenRamda as any,
          mapRamda(
            ifElseRamda(
              hasRamda('entityColumnName'),
              propRamda('entityColumnName'),
              propRamda('entityKey') as any
            )
          )
        )(this);
        allFieldsThisModule.forEach((key: any) => {
          const field = fieldControl[key];

          if (typeof field?.value === 'object') {
            emptyArray = fieldControl[key];
          }

          if (field?.required && field?.visible) {
            this.validationsubformsCallback.forEach((fnS) => fnS());
            this.subFormModuleInstance(key, 'error', []);
            if (
              !field.value ||
              (typeof field?.value === 'object' && emptyArray && emptyArray.value.length === 0) ||
              JSON.stringify(emptyArray?._value) === '{}'
            ) {
              if (typeof field.value == 'boolean') {
                if (String(field.value).length == 0) {
                  this.subFormModuleInstance(key, 'error', ['Campo Obrigatório!']);
                  this.hasError = true;
                }
              } else {
                this.subFormModuleInstance(key, 'error', ['Campo Obrigatório!']);
                this.hasError = true;
              }
            }
          }
          if (!field?.visible) {
            this.validationsubformsCallback.forEach((fnS) => fnS());
            this.subFormModuleInstance(key, 'error', []);
          }
        });
      }
      return this.hasError;
    }

    if (
      this.configuration.type == 'FILE_UPLOAD' &&
      !this.dynamicFormService.formControlStructure.moduleControl[this.configuration.id]?.locked
    ) {
      const error = this.validationUploadCallback();
      this.hasError = error;
      return this.hasError;
    }

    if (this.configuration.type == 'TASK_DISTRIBUTION') {
      const error = this.validationTaskDistributionCallback();
      this.hasError = error;
      return this.hasError;
    }
    if (this.configuration.type == 'CCO' || this.configuration.type == 'CCO_V2') {
      const error = this.validationCCOCallback();
      this.hasError = error;
      return this.hasError;
    }
    return this.hasError;
  };

  public validationUploadCallback;

  public validationTaskDistributionCallback;

  public validationCCOCallback;

  public validationsubformsCallback: Array<Function> = [];

  public setValidationTaskDistributionCallback(eventFunction) {
    this.validationTaskDistributionCallback = eventFunction;
  }

  public setValidationCCOCallback(eventFunction) {
    this.validationCCOCallback = eventFunction;
  }

  public setValidationCallback(eventFunction) {
    this.validationUploadCallback = eventFunction;
  }

  public setValidationSubformCallback(eventFunction) {
    this.validationsubformsCallback.push(eventFunction);
  }

  public saveDataRef(id) {
    this.subFormModuleInstance(this.configuration.entityKey, 'value', id);
  }
  public saveData(event) {
    this.saveDataEmmiter.emit(event);
  }

  private getFormDataErrorTratament(err) {
    this.cloudSaveStatus = 'error';
    this.cloudEmmitter('error');
    this.errorApiEmmiter.emit(err);
  }

  public cloudEmmitter(status): void {
    this.setControlCloud.emit(status);
  }

  public erroApi(event) {
    this.errorApiEmmiter.emit(event);
  }

  private formDataTratament(resp): void {
    if (Object.keys(resp.data).length) {
      Object.keys(resp.data).forEach((key) =>
        this.subFormModuleInstance(key, 'value', resp.data[key])
      );
      this.entityDataProcess = resp.data;
    }
  }

  private analyseDependency(controllData): void {
    const dependencyList = this.configuration.moduleDependency;

    if (dependencyList) {
      this.dependenceMessages.secondary = [];
      const listResolved = dependencyList.map((dep) => {
        const isResolve = controllData[dep.moduleId]
          ? controllData[dep.moduleId].controll.resolved
          : false;
        if (!isResolve) {
          this.dependenceMessages.secondary = [
            ...this.dependenceMessages.secondary,
            ...controllData[dep.moduleId].controll.fieldDependency
              .filter((item) => !item.resolved)
              .map((item) => item.msg),
          ];
        }
        return controllData[dep.moduleId].controll.resolved;
      });
      const last = this.dependencyNotReady;
      this.dependencyNotReady = !listResolved.reduce((acc, value) => acc && value);
      if (this.dependencyNotReady && this.entityDataProcess) {
        if (last !== this.dependencyNotReady) {
          if (this.moduloInicializatedSaveBlock) return;
          Object.keys(this.entityDataProcess).forEach((key) => {
            this.entityDataProcess[key] = null;
            this.subFormModuleInstance(key, 'value', null);
          });
          // this.autoSaveFunction(this.dynamicFormService.getControllStruct());
        }
      }
    }
  }

  public troggleModule(): void {
    if (!this.isOpen) {
      const struct = this.dynamicFormService.formControlStructure;

      if (struct[this.configuration.id]) {
        const fields = struct[this.configuration.id].fields;
        if (!this.entityDataProcess) this.entityDataProcess = {};
        Object.keys(fields).forEach((key) => (this.entityDataProcess[key] = fields[key].value));
      }
      this.isOpen = true;
    } else {
      this.isOpen = !this.isOpen;
    }
  }

  saveValueFileUpload($event) {}

  // public autoSaveFunction(content) {
  //   if(this.formType == 'form-secondary') return;
  //   if(!this.initialized) return;
  //   if(this.moduloInicializatedSaveBlock) return;

  //   const valueToSend = {};
  //   Object.keys(content[this.configuration.id].fields).forEach(key => {
  //     valueToSend[key] = content[this.configuration.id].fields[key].value;
  //   })

  //   if(this.autoSaveInterval ) clearTimeout(this.autoSaveInterval);
  //   this.autoSaveInterval = setTimeout(()=>{
  //     this.cloudSaveStatus = 'saving';
  //     this.cloudEmmitter();
  //     this.taskService.postControllerFormDataAutoSave(this.dataAttrs, valueToSend).subscribe(
  //       (resp: any) => {
  //         if (resp.code == 200) {
  //           this.cloudSaveStatus = 'saved';
  //           this.cloudEmmitter();
  //         } else {
  //           this.getFormDataErrorTratament(resp);
  //         }
  //       },
  //       (err) => this.getFormDataErrorTratament(err)
  //     )
  //   }, 500);
  // }
}
